import { combineReducers } from 'redux';
import { 
    loginState,
    customer,
    customerUpdateDataStep1,
     customerHasErrored, 
     customerIsLoading } from './customer';

import { tupasForm } from './tupasForm'
import { auth, externalAuthentication } from './authentication'
import { applications } from './applications'
import { application, applicationDetails, applicationDescription, attachments } from './application'
import { loan } from './loan'
import { loans } from './loans'
import { user } from './user'
import { companies } from './companies'
import { accessControl} from './accessControl'
import { offer } from './offer'
import { borrower, borrowerLoans } from './borrower'
import { admin } from './admin'
import { repayments } from './repayments'
import {accountTransactions, bkTransactions } from './accountTransactions'
import {currentCompany} from './currentCompany'
import {currentInvoice} from './currentInvoice'

export default combineReducers({
    repayments,
    customer,
    borrower,
    borrowerLoans,
    admin,
    accessControl,
    tupasForm,
    loginState,
    applications,
    companies,
    application,
    applicationDetails,
    applicationDescription,
    attachments,
    user,
    auth,
    loan,
    loans,
    externalAuthentication,
    offer,
    accountTransactions,
    bkTransactions,
    currentCompany,
    currentInvoice
});